import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { LaborCharginGroupPriceResultModel, LaborchargingGroup } from 'projects/Administration/src/app/business-entities/dealer-parts-list-view-model';
import { LaborService } from 'projects/Administration/src/app/business-services/labor.service';
import { PartsBusinessService } from 'projects/Administration/src/app/business-services/parts.service';
import { PaymentMasterService } from 'projects/Administration/src/app/business-services/payment-master.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
@Component({
  selector: 'app-labor-charging-group-price',
  templateUrl: './labor-charging-group-price.component.html'
})
export class LaborChargingGroupPriceComponent implements OnInit {
  //#region  Variable and constructore declaration
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  laborChargingList: LaborCharginGroupPriceResultModel[] = [];
  totalCount: number = 0;
  throttle = 100;
  scrollDistance = 1;
  debounceTimer: any;
  searchTerm: string;
  laborAndItemSalesPriceList:any;
  chargingGroupList:any;
  chargingGroupNo:string = null;
  laborPriceGroup:string = null;
  constructor(
    private spinner: NgxSpinnerService,
    private partsService: PartsBusinessService,
    private paymentService: PaymentMasterService,
    private laborService: LaborService
  ) { }
  //#endregion
  //#region  Component methods
  ngOnInit(): void {
    this.GetLaborandItemSalesPriceGroup();
    this.GetChargingGroupDropDown();
    if (this.chargingGroupNo != undefined) {
      this.partsService.laborchargingGroupRequestmodel.chargingGroupNo = this.chargingGroupNo;
    }
    if (this.laborPriceGroup != undefined) {
      this.partsService.laborchargingGroupRequestmodel.laborPriceGroup = this.laborPriceGroup;
    }
    this.partsService.laborchargingGroupRequestmodel.searchTearm = '';
    this.partsService.laborchargingGroupRequestmodel.chargingGroupNo = '';
    this.partsService.laborchargingGroupRequestmodel.laborPriceGroup = '';
    this.laborChargingList = [];
    this.GetPartSalesPriceList(this.partsService.laborchargingGroupRequestmodel);
  }
  async GetLaborandItemSalesPriceGroup() {
    await this.paymentService.GetLaborandItemSalesPriceGroup().then((response) => {
      this.laborAndItemSalesPriceList = response.responseObject;
    });
  }
  async GetChargingGroupDropDown() {
    this.spinner.show();
    await this.laborService.getChargingGroupDropDown().then((response) => {
      this.spinner.hide()
      this.chargingGroupList = response.responseObject;
    }, _error => {
      this.spinner.hide()
    });
  }
  LaborPriceGroupChange(status: any) {
    if (status == undefined) {
      this.partsService.laborchargingGroupRequestmodel.laborPriceGroup = null;
    } else {
      this.partsService.laborchargingGroupRequestmodel.laborPriceGroup = status.$ngOptionLabel.trim();
    }
    this.partsService.laborchargingGroupRequestmodel.startRecordNumber = 0;
    this.laborChargingList = [];
    this.GetPartSalesPriceList(this.partsService.laborchargingGroupRequestmodel);
  }

  ChargingGroupChange(status: any) {
    if (status == undefined) {
      this.partsService.laborchargingGroupRequestmodel.chargingGroupNo = null;
    } else {
      this.partsService.laborchargingGroupRequestmodel.chargingGroupNo =  status.$ngOptionLabel.trim();
    }
    this.partsService.laborchargingGroupRequestmodel.startRecordNumber = 0;
    this.laborChargingList = [];
    this.GetPartSalesPriceList(this.partsService.laborchargingGroupRequestmodel);
  }
  
  async onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.partsService.laborchargingGroupRequestmodel.sortColumn = column;
    this.partsService.laborchargingGroupRequestmodel.sortDirection = direction;
    this.partsService.laborchargingGroupRequestmodel.startRecordNumber = 0;
    this.laborChargingList = [];
    await this.GetPartSalesPriceList(this.partsService.laborchargingGroupRequestmodel);
  }
  onEnterPress() {
    this.debounceFunction(() => this.onSearchFilter(), 500);
  }
  async onSearchFilter() {
    this.partsService.laborchargingGroupRequestmodel.searchTearm = this.searchTerm;
    this.partsService.laborchargingGroupRequestmodel.startRecordNumber = 0;
    this.laborChargingList = [];
    this.GetPartSalesPriceList(this.partsService.laborchargingGroupRequestmodel);
  }
  debounceFunction(func, delay) {
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }
  loadMoreData(event) {
    this.debounceFunction(() => this.onScrollDown(event), 200);
  }
  onScrollDown(_ev) {
    if (this.totalCount > this.laborChargingList.length) {
      this.partsService.laborchargingGroupRequestmodel.startRecordNumber = this.laborChargingList.length
      this.GetPartSalesPriceList(this.partsService.laborchargingGroupRequestmodel);
    }
  }
  //#endregion
  //#region API Methods
  async GetPartSalesPriceList(_partRequestModel: LaborchargingGroup) {
    this.spinner.show();
    await this.partsService.GetLaborChargingGroupPrice(this.partsService.laborchargingGroupRequestmodel).then(res => {
      if (res.responseObject.length > 0) {
        this.laborChargingList.push(...res.responseObject);
        this.totalCount = res.responseObject[0].totalCount;
      }
      else {
        this.spinner.hide();
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  //#endregion
}
